import { ORDERS_PARTNER_FILTER_EVENTS } from './global-events';

export const ordersPartnerFilterOptions = [
  {
    id: 'all',
    name: 'Вся система',
    event: ORDERS_PARTNER_FILTER_EVENTS.ORDERS_PARTNER_FILTER_ALL,
    options: {
      type: 'checkbox',
      activeFilter: false,
    }
  },
];
